export const announcement = [
  {
    name: 'Index',
    url: '/one-app/announcement',
    icon: 'icon-home'
  },
  {
    name: 'Create',
    url: '/one-app/announcement/create',
    icon: 'icon-plus'
  }
];
